import React from "react";
import "./Header.scss";

export default function Header() {
  return (
    <div className="header">
      <div className="titles">
        <h1 id="title1">Mars</h1>
        <h1 id="title2">capade</h1>
      </div>
      <div className="separator"></div>
    </div>
  );
}
